import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { toast } from "react-toastify";
import MessageNotification from "../components/MessageNotification";
import { getRouteIndex, handleNavigate } from "../utils/common";
import {
  menuDynamicRoute,
  menuStaticRoute,
  user_type,
} from "../utils/constant";

export default function CoolbizAuthHeader({ ...props }) {
  const { liveChats } = useAuth();
  const { user, accessType } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const currentLocation = location.pathname;
  // const { switchUserForDemoPerpos } = useAuth();
  // const [checked, setChecked] = useState(false);

  // const handleChange = () => {
  //   setChecked(!checked);
  //   switchUserForDemoPerpos(checked ? 'user' : 'admin');
  // };

  const languages = [
    { code: "en", label: "Eng", flag: "/images/flags/eng-icon.png" },
    { code: "hi", label: "Ind", flag: "/images/flags/india-icon.png" },
    { code: "fr", label: "Fre", flag: "/images/flags/french-icon.png" },
    { code: "es", label: "Spa", flag: "/images/flags/spanish-icon.png" },
  ];
  const [selectedLang, setSelectedLang] = useState(languages[0]);
  const [showLangDropdown, setShowLangDropdown] = useState(false);

  const handleLangSelect = (lang) => {
    setSelectedLang(lang);
    setShowLangDropdown(false);
    // You can save in localStorage or call i18n.changeLanguage(lang.code)
  };

  return (
    <div className="top-head">
      <button className="navToggle" onClick={() => props.setNavToggle(true)}>
        <span className="hamburger-menu">
          <span className="bar"></span>
        </span>
      </button>
      {user?.isNextPlan === 1 &&
        user?.isUpDownGrade === 1 &&
        user?.isGracePeriod === 0 && (
          <div className="top-head_left">
            <div className="alert alert-danger p-0 m-0" role="alert">
              <p className="pb-0 m-0">
                Downgrade in progress — it will apply after your current plan
                expires.
              </p>
            </div>
          </div>
        )}
      {user?.isNextPlan === 1 &&
        user?.isUpDownGrade === 1 &&
        user?.isGracePeriod === 1 && (
          <div className="top-head_left">
            <div className="alert alert-danger p-0 m-0" role="alert">
              <p className="pb-0 m-0">
                Downgrade renewal payment failed. Please pay your subscription
                fee to continue receiving uninterrupted service.
              </p>
            </div>
          </div>
        )}
      {user?.isNextPlan === 1 &&
        user?.isUpDownGrade === 2 &&
        user?.isGracePeriod === 0 && (
          <div className="top-head_left">
            <div className="alert alert-danger p-0 m-0" role="alert">
              <p className="pb-0 m-0">
                Upgrade in progress — it will apply after your current plan
                expires.
              </p>
            </div>
          </div>
        )}
      {user?.isNextPlan === 1 &&
        user?.isUpDownGrade === 2 &&
        user?.isGracePeriod === 1 && (
          <div className="top-head_left">
            <div className="alert alert-danger p-0 m-0" role="alert">
              <p className="pb-0 m-0">
                Upgrade renewal payment failed. Please pay your subscription fee
                to continue receiving uninterrupted service.
              </p>
            </div>
          </div>
        )}
      {user?.isNextPlan === 0 &&
        user?.isUpDownGrade === 0 &&
        user?.isGracePeriod === 1 && (
          <div className="top-head_left">
            <div className="alert alert-danger p-0 m-0" role="alert">
              <p className="pb-0 m-0">
                You already have one Payment in queue. Please pay your
                subscription fee to continue receiving uninterrupted service.
              </p>
            </div>
          </div>
        )}
      {/* You already have one Payment in queue. Please pay your subscription fee to continue receiving uninterrupted service. */}
      {/* {user?.isNextPlan == 1 && user?.isUpDownGrade == 1 ? (
        <div className="top-head_left">
          <div className="alert alert-danger p-0 m-0" role="alert">
            <p className="pb-0 m-0">
              Downgrade in progress — it will apply after your current plan
              expires.
            </p>
          </div>
        </div>
      ) : null}


      {user?.isNextPlan == 1 &&
      user?.isUpDownGrade == 2 ?
       (
        <div className="top-head_left">
          <div className="alert alert-danger p-0 m-0" role="alert">
            <p className="pb-0 m-0">
              You already have one Payment in queue. Please pay your
              subscription fee to continue receiving uninterrupted service.
            </p>
          </div>

          {user?.isGracePeriod == 1 ? <div className="alert alert-danger p-0 m-0" role="alert">
            <p className="pb-0 m-0">
              Your Upgrade Process is failed. 
            </p>
          </div> : null}
        </div>
      ) : null}

      {user?.isNextPlan == 1 &&
      user?.isUpDownGrade == 1 ?
       (
        <div className="top-head_left">
          <div className="alert alert-danger p-0 m-0" role="alert">
            <p className="pb-0 m-0">
              You already have one Payment in queue. Please pay your
              subscription fee to continue receiving uninterrupted service.
            </p>
          </div>
        </div>
      ) : null} */}
      {/* user?.isGracePeriod == 1 ? */}
      <div className="top-head_right">
        <ul className="user-notification">
          {/* <li className="notification">
  
              Need to remove after api 
              <Form>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  label={checked ? 'Admin View' : 'User view'}
                  checked={checked}
                  onChange={handleChange}
                />
              </Form>
            </li> */}

          {/* ********************* */}
          {user && ![1, 5, 6].includes(user?.userType) && (
            <li className="notification">
              <div className="cta-purple-with-text">
                {user?.isTrial == 1
                  ? "Free Trial - Active"
                  : user?.subscriptionStatus.toString() === "1"
                    ? `${user?.userSubscription?.plan?.planName} - Active`
                    : `${user?.userSubscription?.plan?.planName} - Inactive`}
              </div>
            </li>
          )}
          {liveChats?.length > 0 &&
            user?.menus.some((menu) => menu.menuName === "human-takeover") && (
              <li className="notification">
                <a
                  className="ongoing-chats-notification"
                  onClick={() =>
                    handleNavigate(
                      navigate,
                      `${
                        menuDynamicRoute["human-takeover"].route[
                          getRouteIndex(accessType)
                        ]
                      }?tab=2`,
                      currentLocation,
                    )
                  }
                >
                  <img
                    src="/images/icons/menu-chat-history.svg"
                    alt="chat-icon"
                  />
                  <span>{liveChats?.length}</span>
                </a>

                {/* <Link to={user?.userType === 1
                ? "/admin/notifications" :user?.userType === 3?"/agency/notifications":user?.userType === 5?"/affiliate/notifications": "/notifications"}> */}
                {/*<i className="fa-sharp fa-light fa-bell"></i>*/}
                {/* <img src="/images/icons/bell-icon.svg" alt="bell-icon" /> */}
                {/* <spna>2</spna> */}
                {/* </Link> */}
              </li>
            )}
          <li className="notification">
            <a
              onClick={() =>
                handleNavigate(
                  navigate,
                  menuStaticRoute[5]?.notifications?.route[
                    getRouteIndex(accessType)
                  ],
                  currentLocation,
                )
              }
            >
              <img src="/images/icons/bell-icon.svg" alt="bell-icon" />
            </a>
            {/* <Link to={user?.userType === 1
                ? "/admin/notifications" :user?.userType === 3?"/agency/notifications":user?.userType === 5?"/affiliate/notifications": "/notifications"}> */}
            {/*<i className="fa-sharp fa-light fa-bell"></i>*/}
            {/* <img src="/images/icons/bell-icon.svg" alt="bell-icon" /> */}
            {/* <spna>2</spna> */}
            {/* </Link> */}
          </li>
          <li className="login-user">
            <a
              onClick={() => {
                handleNavigate(
                  navigate,
                  menuStaticRoute[3]?.profile?.route?.[
                    getRouteIndex(accessType)
                  ],
                  currentLocation,
                );
              }}
            >
              <span>
                <img
                  src={
                    !!user?.fileLink ? user?.fileLink : "/images/images-100.png"
                  }
                  alt="images-100"
                />
              </span>
            </a>
            {/* <Link to={user?.userType === 1 ? "/admin/profile" : user?.userType === 5 ? "/affiliate/profile" : user?.userType === 3 ? "/agency/profile" : "/profile"}>
                <span><img src={!!user?.fileLink ? user?.fileLink : "/images/images-100.png"} alt="images-100" /></span>
              </Link> */}
          </li>

          {/* Language Dropdown with Flag + Arrow Image */}
          {/* <li className="lang_wrap" onClick={() => setShowLangDropdown(!showLangDropdown)}>
              <div className="lang-block">
                <img src={selectedLang.flag} alt={selectedLang.code} style={{ width: 26, height: 26 }} />
                <span>{selectedLang.label}</span>
                <img src="/images/down-arrow.png" alt="dropdown-arrow" style={{ width: 12, height: 7 }} />
              </div>

              {showLangDropdown && (
                <ul className="lang-lists">
                  {languages.map((lang) => (
                    <li key={lang.code} onClick={() => handleLangSelect(lang)}>
                      <img src={lang.flag} alt={lang.code} style={{ width: 20, height: 20 }} />
                      {lang.label}
                    </li>
                  ))}
                </ul>
              )}
            </li> */}
        </ul>
      </div>
    </div>
  );
}
